import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {Odjel} from '../models/Odjel'
import {FunkcijaModel} from '../models/FunkcijaModel'

const API_URL = process.env.REACT_APP_API_URL
const FUNKCIJA_DROPDOWN = `${API_URL}/funkcijaDropdown`
const API = `${API_URL}/funkcija`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for Funkcija dropdown data.
export async function getFunkcija() {
  return await axios.get<Array<Option>>(FUNKCIJA_DROPDOWN, {headers: headers})
}
export async function getAllFunkcija(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<Odjel>>(API, {headers: headers, params: params})
}

export async function saveFunkcija(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchFunkcija(Id: number): Promise<Partial<FunkcijaModel>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateFunkcija(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error) {
    console.error('Error deleting Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteFunkcija(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error) {
    console.error('Error deleting Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
